import { FormikControl, InputError } from "@/imports-files/common/common";
import {CreateScoreStyle} from '@/imports-files/pages/clients/jobs/scorecards'

export function AddScoreCardLinkComponent(props)
{
  return(
          <div className={`${CreateScoreStyle.LightBox}`}>
            <div className={`${CreateScoreStyle.LightBox__Competency} ${CreateScoreStyle.LightBox__CompetencyLink} `}>
            <div className={`${CreateScoreStyle.Dpflex}`}>
                  <label>Link </label>
            </div>
            <div className={`${CreateScoreStyle.Dpflex}`}>
            <FormikControl control= "ScoreCardInput"
                            type =  "text"
                            placeholder='Add link here'
                            name = {props.name}
                            formik = {props.formik}
                            disabled = {!props.editable}
                            className = {`${CreateScoreStyle.addLink} ${CreateScoreStyle.Form__Input}`}
                            style={InputError(props.formik, props.name)}
                            custom_class={`${CreateScoreStyle.ScorecardInputError}`}
                          />
              </div>
              </div>
            </div>
        )
}
